import { render, staticRenderFns } from "./wenwu.vue?vue&type=template&id=5872714f&scoped=true&"
import script from "./wenwu.vue?vue&type=script&lang=js&"
export * from "./wenwu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5872714f",
  null
  
)

export default component.exports